import { useQuery } from 'react-query';
import { UserType } from '../types/types';
import hash from 'object-hash';

const baseRoute = process.env.REACT_APP_BASE_URL;

export type PostMesInactivoParams = { id: string, mes: number, anio: number, inactivo: boolean } | null;

async function mesInactivoApiCall(params?: PostMesInactivoParams, user?: UserType | null) {
  if (!user?.token || !params) return null;
  if (!params?.id || !params?.mes || !params?.anio) return null;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${user.token}`,

  };
  const response = await fetch(
    `${baseRoute}/api/marcarMesInactivo`,
    { headers, body: JSON.stringify(params), method: 'POST' },
  );
  if (!response.ok) {
    throw new Error('Problem fetching data');
  }
  const resp = await response.json();
  return resp as UserType;
}

export function usePostMesInactivoAlumno(params?:PostMesInactivoParams, user?: UserType | null) {
  return useQuery<UserType | null, Error>(
    ['postMesInactivoApi', hash(params || ''), hash(user ?? '')],
    () => mesInactivoApiCall(params, user), {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      retry: false,
    },
  );
}
